export const LOCAL_STORAGE_TOKEN = '@parkdepot/auth/token'

export const LOCAL_STORAGE_setToken = (token: string) => {
    localStorage.setItem(LOCAL_STORAGE_TOKEN, token)
}

export const LOCAL_STORAGE_getToken = (): string | null => {
    const token = localStorage.getItem(LOCAL_STORAGE_TOKEN)
    return token
}

export const LOCAL_STORAGE_removeToken = () => {
    localStorage.removeItem(LOCAL_STORAGE_TOKEN)
}
